import { StepDto } from '@/modules/onboarding/status/domain/dtos';
import { SectionBase } from '@/modules/onboarding/status/domain/services/onboarding-step/step';

export default class FinancialInformation implements SectionBase {
  getStepAndSubStep(): StepDto {
    return {
      step: 5,
      substep: 1,
    };
  }
}
